module.exports = __webpack_public_path__ + "media/images/admin/icons/gear-05493350272a1a7c3254757264daecd1.svg";